import { CSSProperties, FC } from "react";
import { COLOR_VALUES } from "../../../lib/types/shared/enums";
import { ParagraphProps } from "../../../lib/types/shared/reactInherited";

const G_Text: FC<ParagraphProps> = ({
  children,
  italic,
  underline,
  weight,
  p,
  px,
  py,
  m,
  mx,
  my,
  mt,
  mb,
  pt,
  pb,
  color,
  className,
  bg,
  dimension,
  pointer,
  ...rest
}): JSX.Element => {
  const fontSize = (() => {
    switch (dimension) {
      case "extra-large":
        return "text-[24px]";
      case "large":
        return "text-[21px]";
      case "medium":
        return "text-[16px]";
      case "normal":
        return "text-[14px]";
      case "caption":
        return "text-[12px]";
      case "small":
        return "text-[10px]";
      default:
        return "text-[14px]";
    }
  })();

  const classes = `${fontSize} font-${weight} ${italic && "italic"} ${
    underline && "underline"
  } mx-${mx} my-${my} px-${px} py-${py} mt-${mt} mb-${mb} pt-${pt} pb-${pb} ${className} ${
    pointer ? "cursor-pointer" : "cursor-default"
  }`;

  const styles: CSSProperties = {
    color: COLOR_VALUES[color || "ox_2_black"],
    background: bg ? COLOR_VALUES[bg] : "none",
    padding: `${p || 0}px`,
    margin: `${m || 0}px`,
    marginBottom: `${mb || 0}px`
  };

  return (
    <p style={styles} className={classes} {...rest}>
      {children}
    </p>
  );
};

export default G_Text;
